// extracted by mini-css-extract-plugin
export default {"backdrop":"styles_backdrop__PnfAj","active":"styles_active__Zcd9S","modal":"styles_modal__5D1PS"};